// Role helpers shared by App shell, module selector, and Container Planner.
// CUSTOMER_PRO is a restricted "external customer" role: their entire ERP
// surface collapses down to the visual Container Planner as an anonymised
// Order Optimizer — draft-only PO uploads, private saved splits, no /pos,
// no /inventory, no truck-spec editor, no placement auditor.

export const CUSTOMER_PRO_ROLE_ID = "role-customer-pro";
export const SUPER_ADMIN_ROLE_ID = "role-super-admin";

export function isCustomerPro(user) {
  if (!user) return false;
  const roleIds = user.role_ids || [];
  if (roleIds.includes(SUPER_ADMIN_ROLE_ID)) return false;
  return roleIds.includes(CUSTOMER_PRO_ROLE_ID);
}

export const CUSTOMER_PRO_LANDING = "/safety/container-planner";
